"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-inputtool-emoji chatsi-emoji-panel"
  }, [_c('div', {
    staticClass: "chatsi-emoji-grid",
    on: {
      "mousedown": function ($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l(_vm.allEmojis, function (emoji) {
    return _c('button', {
      key: emoji,
      staticClass: "chatsi-emoji-button",
      attrs: {
        "type": "button"
      },
      on: {
        "mousedown": function ($event) {
          $event.preventDefault();
        },
        "click": function ($event) {
          $event.preventDefault();
          return _vm.insertEmoji(emoji);
        }
      }
    }, [_vm._v(" " + _vm._s(emoji) + " ")]);
  }), 0)]);
};
var staticRenderFns = exports.staticRenderFns = [];